import { bindCommandToKey } from "../commands/commands";
export const createKeybindingByPlatform = (platform, command) => {
    return (state, dispatch, view) => {
        const isMac = typeof navigator !== "undefined" && /Mac/.test(navigator.platform);
        if ((platform === "macos" && isMac) || (platform === "other" && !isMac)) {
            return bindCommandToKey(command)(state, dispatch, view);
        }
        return false;
    };
};
